<template>
  <div class="table-wrapper">
    <table>
      <caption class="visually-hidden">
        {{
          $t('API_ERRORS_REPORT.HEADER')
        }}
      </caption>
      <thead>
        <tr>
          <th>{{ $t('API_ERRORS_REPORT.TABLE.CREATED_AT') }}</th>
          <th>{{ $t('API_ERRORS_REPORT.TABLE.INBOX') }}</th>
          <th>{{ $t('API_ERRORS_REPORT.TABLE.USER') }}</th>
          <th>{{ $t('API_ERRORS_REPORT.TABLE.ERROR') }}</th>
          <th>{{ $t('API_ERRORS_REPORT.CHART.IS_TEMPLATE') }}</th>
          <th>{{ $t('API_ERRORS_REPORT.TABLE.LINK_TO_CONVERSATION') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in paginatedData"
          :key="index"
          :class="{ 'striped-row': index % 2 !== 0 }"
        >
          <td>{{ formatDate(item.created_at) }}</td>
          <td>{{ item.inbox_name || '-' }}</td>
          <td>{{ item.sender_name || '-' }}</td>
          <td>{{ item.error || '-' }}</td>
          <td>{{ item.is_template || '-' }}</td>
          <td>
            <a
              v-if="item.link_conversation"
              :href="item.link_conversation"
              target="_blank"
              rel="noopener noreferrer"
              :title="item.link_conversation"
            >
              {{ truncate(item.link_conversation) }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="pagination">
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
        {{ $t('API_ERRORS_REPORT.PAGINATION.PREVIOUS') }}
      </button>
      <span>
        {{ $t('API_ERRORS_REPORT.PAGINATION.PAGE') }} {{ currentPage }}
        {{ $t('API_ERRORS_REPORT.COMMON.OF') }} {{ totalPages }}
      </span>
      <button
        @click="goToPage(currentPage + 1)"
        :disabled="currentPage === totalPages"
      >
        {{ $t('API_ERRORS_REPORT.PAGINATION.NEXT') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApiErrorsTable',
  props: {
    apiErrorsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 100,
    };
  },
  computed: {
    sortedData() {
      return [...this.apiErrorsData].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.sortedData.slice(start, start + this.perPage);
    },
    totalPages() {
      return Math.ceil(this.apiErrorsData.length / this.perPage);
    },
  },
  methods: {
    formatDate(dateString) {
      return new Date(dateString).toLocaleString('pt-BR', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    truncate(text, maxLength = 50) {
      if (!text || typeof text !== 'string') return '-';
      return text.length > maxLength
        ? text.slice(0, maxLength - 3) + '...'
        : text;
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #ddd;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;
}

thead {
  background-color: #2563eb;
  color: white;
}

th,
td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  word-break: break-word;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.striped-row {
  background-color: #f9f9f9;
}

a {
  color: #2563eb;
  text-decoration: underline;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
}

.pagination button {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

td span {
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
</style>
